import { API } from 'app/utils/client';
import { IReport } from 'app/models';
import { CRUDService } from './api';

export class ReportService extends CRUDService<IReport> { }

const instance = new ReportService(API, 'v1/reports');
export default instance;
